import { attr } from '@ember-data/model';
import BaseModel from 'volta/models/base-model';

export const ResourceName = {
  singular: 'activity',
  plural: 'activities'
};

export default class Activity extends BaseModel {
  @attr('string') command!: string;
  @attr() payload: any;
  @attr('string') entityId?: string;
  @attr('string') entityType?: string;
  @attr('boolean', { defaultValue: () => false }) entityIsNew?: boolean;
  @attr('string') userId!: string;
  @attr('string') userName!: string;
}

// DO NOT DELETE: this is how TypeScript knows how to look up your models.
declare module 'ember-data/types/registries/model' {
  export default interface ModelRegistry {
    activity: Activity;
  }
}
